import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";
(() => {
  if (!customElements.get("article-cards-slider")) {
    class ArticleCardsSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setVariables();
        this.initSwiper();
      }

      setVariables() {
        this.slidesPerViewDesktop = this.getAttribute("data-columns-desktop");
        this.gapBetweenCards = this.getAttribute("data-gap") || 0;
      }

      initSwiper() {
        new Swiper(this, {
          slidesPerView: "auto",
          slidesOffsetAfter: 0,
          navigation: false,
          pagination: false,
        });
      }
    }

    customElements.define("article-cards-slider", ArticleCardsSlider);
  }
})();
